import UserService from "./user-service";
import {Service} from "../../entity/core/service";
import OrganizationService from "./organization-service";
import CountyService from "./county-service";
import {Store} from "../../entity/core/store";
import {useStore} from "../store/store";
import StateService from "./state-service";
import TitleSectionTemplateService from "./title-section-template-service";
import TitleService from "./title-service";
import SectionService from "./section-service";
import DocumentService from "./document-service";
import TitleTemplateService from "./title-template-service";
import SearchService from "./search-service";
import SubscriptionService from "./subscription-service";
import ScraperConfigService from "./scraper-config-service";
import CountyLinkService from "./county-link-service";
import AuditLogsService from "./audit-logs-service";
import ProjectService from "./project-service";
import {InvoiceTemplateService} from "./invoice-template-service";
import {BrandingTemplateService} from "./branding-template-service";
import TitleSummaryRequestService from "./title-summary-request-service";
import TitleSummaryTemplateService from "./title-summary-template-service";
import LineListRequestService from "./line-list-request-service";
import LineListTemplateService from "./line-list-template-service";
import MetadataService from "./metadata-service";
import MarketplaceService from "./marketplace-service";

const getServices = (store: Store): Service => {
    return {
        userService: new UserService(store.userStore),
        organizationService: new OrganizationService(store.organizationStore),
        countyService: new CountyService(store.countyStore),
        stateService: new StateService(store.stateStore),
        titleSectionTemplateService: new TitleSectionTemplateService(store.titleSectionTemplateStore),
        titleService: new TitleService(store.titleStore),
        sectionService: new SectionService(store.sectionStore),
        documentService: new DocumentService(store.documentStore, new TitleService(store.titleStore)),
        titleTemplateService: new TitleTemplateService(store.titleTemplateStore),
        searchService: new SearchService(store.searchStore),
        subscriptionService: new SubscriptionService(store.subscriptionStore),
        scraperConfigService: new ScraperConfigService(store.scraperConfigStore),
        countyLinkService: new CountyLinkService(store.countyLinkStore),
        auditLogsService: new AuditLogsService(store.auditLogsStore),
        projectService: new ProjectService(store.projectStore, store.searchStore),
        invoiceRequestService: new InvoiceTemplateService(store.invoiceTemplateStore),
        brandingTemplateService: new BrandingTemplateService(store.brandingTemplateStore),
        titleSummaryRequestService: new TitleSummaryRequestService(store.titleSummaryRequestStore),
        titleSummaryTemplateService: new TitleSummaryTemplateService(store.titleSummaryTemplateStore),
        lineListRequestService: new LineListRequestService(store.lineListRequestStore),
        lineListTemplateService: new LineListTemplateService(store.lineListTemplateStore),
        metadataService: new MetadataService(store.metadataStore),
        marketplaceService: new MarketplaceService(store.marketplaceStore)
    }
}

export const useService = () => {
    return getServices(useStore());
}


